import { ThemeEvents } from '@theme/events';

class AvtBackorderRequest extends HTMLElement {
  #abortController = null;

  connectedCallback() {
    this.#abortController?.abort();
    this.#abortController = new AbortController();
    this.closest('.shopify-section')?.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate, {
      signal: this.#abortController.signal,
    });
  }

  disconnectedCallback() {
    this.#abortController?.abort();
  }

  #handleVariantUpdate = (event) => {
    if (String(event.detail?.data?.productId ?? '') !== this.dataset.productId) return;

    const variant = event.detail?.resource;
    this.hidden = !variant || variant.available !== false || variant.inventory_management !== 'shopify' ||
      variant.inventory_policy !== 'deny' || Number(variant.inventory_quantity) > 0;
    if (!variant) return;

    const sku = this.querySelector('[data-avt-backorder-sku]');
    const variantId = this.querySelector('[data-avt-backorder-variant]');
    const variantTitle = this.querySelector('[data-avt-backorder-title]');
    const productUrl = this.querySelector('[data-avt-backorder-url]');
    if (sku instanceof HTMLInputElement) sku.value = String(variant.sku ?? '');
    if (variantId instanceof HTMLInputElement) variantId.value = String(variant.id ?? '');
    if (variantTitle instanceof HTMLInputElement) variantTitle.value = String(variant.title ?? '');
    if (productUrl instanceof HTMLInputElement) {
      const url = new URL(productUrl.value);
      url.searchParams.set('variant', String(variant.id ?? ''));
      productUrl.value = url.href;
      const returnTo = this.closest('form')?.querySelector('input[name="return_to"]');
      if (returnTo instanceof HTMLInputElement) returnTo.value = `${url.pathname}${url.search}`;
    }
  };
}

if (!customElements.get('avt-backorder-request')) {
  customElements.define('avt-backorder-request', AvtBackorderRequest);
}
